module.exports = __webpack_public_path__ + "img/ico_home--wh.e06204fb.svg";